const ExpenseDataValidation = (expenseData) => {
    let isValid = true;
    let errors = {
        category: null,
        amount: null,
    };




    // Validate Expense Category
    if (!expenseData?.category?.trim()) {
        errors.category = "Please select or enter a valid category!";
        isValid = false;
    }

    // Validate Amount
    if (!expenseData?.amount || expenseData.amount <= 0 || isNaN(expenseData.amount)) {
        errors.amount = "Please enter a amount!";
        isValid = false;
    }

    if (!expenseData?.expenseName?.trim()) {
        errors.expenseName = "Please enter a valid Expense name!";
        isValid = false;
    }
    return { isValid, errors };
};

export default ExpenseDataValidation;
